import { render, staticRenderFns } from "./Mockup.vue?vue&type=template&id=57468117&scoped=true&"
import script from "./Mockup.vue?vue&type=script&lang=ts&"
export * from "./Mockup.vue?vue&type=script&lang=ts&"
import style0 from "./Mockup.vue?vue&type=style&index=0&id=57468117&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57468117",
  null
  
)

export default component.exports